module.exports = __webpack_public_path__ + "img/zap-off.a8947bb5.svg";